import { ArrowUturnLeftIcon as BaseBackButtonIcon } from "@heroicons/react/24/outline";

const BackButtonIcon = (props) => {
  return <BaseBackButtonIcon {...props} />;
};

export default BackButtonIcon;
